import type {
  FilterOption,
  FilterCategory,
  DefaultFilterOption,
} from '../../models/Filter';

type BuildMapsResult = {
  singularCategoriesMap: Map<string, FilterOption>;
  defaultOptionsMap: Map<string, FilterOption>;
  multipleCategoriesMap: Map<string, Map<string, DefaultFilterOption>>;
};

export default function initializeMaps(
  filterCategories: FilterCategory[],
): BuildMapsResult {
  const singularCategoriesMap = new Map<string, FilterOption>();
  const multipleCategoriesMap = new Map<
    string,
    Map<string, DefaultFilterOption>
  >();
  const defaultOptionsMap = new Map<string, FilterOption>();

  filterCategories.forEach((category) => {
    const { id: categoryId } = category;
    if (category.type === 'singular') {
      singularCategoriesMap.set(categoryId, category.defaultOption);
      defaultOptionsMap.set(categoryId, category.defaultOption);
    } else {
      multipleCategoriesMap.set(
        categoryId,
        new Map<string, DefaultFilterOption>(),
      );

      if (category.defaultOption) {
        multipleCategoriesMap.set(
          categoryId,
          new Map<string, DefaultFilterOption>().set(
            category.defaultOption.id,
            category.defaultOption as DefaultFilterOption,
          ),
        );
        defaultOptionsMap.set(categoryId, category.defaultOption);
      }
    }
  });

  return {
    singularCategoriesMap,
    multipleCategoriesMap,
    defaultOptionsMap,
  };
}
